export const SCROLL_EVENT_TARGETS = {
  SLIDER: 'slider',
  TABLE: 'table'
}
